import { z } from 'zod';

/**
 * Chain of custody for HubSpot rep cards.
 *
 * A card's Lambda authenticates with the shared admin API key, so
 * `requireAdminAuth` can only report `api_key` — which would attribute every
 * rep-filed submission to the same anonymous caller. The Lambda passes the
 * rep's own identity here instead.
 *
 * A route honours this ONLY for `api_key` callers and ignores it for session
 * admins, so a logged-in admin cannot file under someone else's name. The
 * `hubspot:` prefix is required so the stored value always says where the
 * attribution came from and can never impersonate a plain admin email.
 *
 * Shared by every on-behalf admin route (partner applications, tax-exemption
 * requests) so the accepted shape cannot drift between the cards.
 */
export const submittedByOverrideSchema = z
  .string()
  .trim()
  .max(255)
  .regex(/^hubspot:[^\s]+@[^\s]+$/, 'submittedBy must look like hubspot:<rep email>')
  .optional();
